<template>
  <header>
    <div id="logo">
      <router-link to="/api_reference">
        <img
            class="directcloud-box-logo"
            :src="logo"
            style="padding: 0.5em 0.2em 0 2em; height: 32px"
            alt="directcloud-logo"
        />
      </router-link>
      <div class="title">
        <span>APIリファレンス</span>
      </div>
    </div>

    <nav>
      <div v-if="this.$route.name === 'detail'" class="selectPilot">
        <select class="selectPilot styled-select" @change="onChange($event)">
          <option
              value="ユーザー"
              :selected="$route.params.pilot === 'ユーザー'"
          >
            ユーザーAPI
          </option>
          <option value="管理者" :selected="$route.params.pilot === '管理者'">
            管理者API
          </option>
        </select>
      </div>

      <div class="search-input-wrapper">
        <input
            class="form-control input-header-search search__input"
            placeholder="検索"
            v-model="search_content"
            id="search_input"
            @keydown="searchForContent($event)"
        />
        <div
            style="position: absolute; top: 0; right: 0; line-height: normal"
        >
          <button
              class="btn search__btn"
              type="button"
              style="padding: 4px 6px 5px 6px; background-color: transparent"
              @click.prevent="searchButton"
          >
            <img
                class="img-responsive"
                :src="magnifying_glass"
                style="width: 20px; height: 20px"
            />
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>

const logo = new URL('../data/image/API_header_logo.png', import.meta.url)
const magnifying_glass = new URL('../data/image/magnifying_glass.png', import.meta.url);

export default {
  name: 'VueHeader',
  data() {
    return {
      search_content: '',
      magnifying_glass: magnifying_glass.pathname,
      logo: logo.pathname,
    };
  },
  methods: {
    onChange(e) {
      this.$router.push({
        name: 'detail',
        params: {pilot: e.target.value, id: 'Auth'},
      });
    },
    searchForContent(e) {
      if (e.isComposing) return;
      if (e.key === 'Enter') {
        this.$router.push({
          name: 'search',
          params: {content: this.search_content},
        });
        this.search_content = '';
      }
    },
    searchButton() {
      this.$router.push({
        name: 'search',
        params: {content: this.search_content},
      });
      this.search_content = '';
    },
  },
};
</script>

<style scoped lang="scss">
header {
  position: sticky;
  top: 0;
  background: #408fdc;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 500;

  #logo {
    display: flex;
  }

  // 타이틀 위치조정
  span {
    position: relative;
    top: 0.35em;
    font-size: 2em;
    line-height: 1.6;
    font-family: arial, sans-serif;
  }

  nav {
    margin-right: 2.2rem;
    display: flex;
    align-items: center;
  }

  a {
    color: #fff;
    text-decoration: none;
    padding-right: 13px;
    transition: color 125ms;
  }

  .search-input-wrapper {
    position: relative;
    min-width: 250px;
    width: calc(100% - 250px);
    padding-top: 0px;
    float: left;
  }

  .search__input {
    border: 1px solid #fff;
    border-radius: 3px;
    display: inline-block;
  }

  .search__btn {
    background-color: #ffffff;
    color: #408fdc;
    font-family: Meiryo, sans-serif;
    border: 1px solid #fff;
    border-radius: 3px;
    display: inline-block;
  }

  .form-group {
    margin-bottom: 0;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .form-control {
    display: block;
    width: 235px;
    padding: 8px 8px 6px 10px;
    font-size: 15px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 0px solid #ccc;
    border-radius: 3px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  }

  .btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    padding: 6px 12px;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    background-color: transparent;
  }

  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
  }

  input::placeholder {
    color: rgb(180, 180, 180);
  }

  button:focus,
  input:focus {
    outline: none;
  }

  .selectPilot {
    margin-right: 7px;
    width: 120px;
  }

  .styled-select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    /* スタイル */
    display: inline-block;
    width: 100%;
    margin: 1em 0;
    padding: 0.3em 1.5em 0.3em 0.65em;
    cursor: pointer;
    line-height: 1.5;
    font-size: 1.15em;
    font-weight: 500;
    color: #484d54;
    font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px transparent;
    box-shadow: 0 3px 3px -2px rgba(3, 29, 41, 0.15);
    /* 三角マークを作る */
    background-image: linear-gradient(
            45deg,
            transparent 50%,
            rgba(0, 0, 0, 0.4) 50%
    ),
    linear-gradient(135deg, rgba(0, 0, 0, 0.4) 50%, transparent 50%);
    background-size: 5px 5px, 5px 5px;
    background-position: calc(100% - 15px) 50%, calc(100% - 10px) 50%;
    background-repeat: no-repeat;
  }

  .styled-select:focus {
    outline: 0;
    border-color: #b0c5ff;
  }

  /* IEでデフォルトの矢印を消す */
  .styled-select::-ms-expand {
    display: none;
  }
}
</style>
